import { AfterViewInit, Component, ElementRef, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MenuComponent } from '../../layout/menu/menu.component';
import { RodapeComponent } from '../../layout/rodape/rodape.component';

@Component({
  selector: 'app-rede',
  imports: [MenuComponent, RodapeComponent],
  templateUrl: './rede.component.html',
  styleUrl: './rede.component.css'
})
export class RedeComponent implements AfterViewInit {

  @ViewChild('promoVideo') promoVideo!: ElementRef<HTMLVideoElement>;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const video = this.promoVideo.nativeElement;

      if (video && typeof video.play === 'function') {
        video.play().catch(err => {
          console.warn('Autoplay blocked:', err);
        });
      }
    }
  }

}
